export const boxShadowNdp = (n: number) => `
  box-shadow: 0px ${n + 1}px ${n + 1}px 0px rgba(150, 150, 150, 0.55),
              0px 0px ${n}px ${n}px rgba(150, 150, 150, 0.20);
`;
